import React, { useState, useEffect } from "react";
import { Button, Popover } from "@mui/material";
import CoreFilterButtonIcon from "../../../app/core/components/CoreFilterButtonIcon/CoreFilterButtonIcon";
import PracticeFilter from "../../../app/core/components/PracticeFilter/PracticeFilter";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useTranslation } from "react-i18next";
import UserFilter from "../../../app/core/components/UserFilter/UserFilter";
import { useSelector } from "react-redux";

const ChatFilter = ({
  filter,
  setFilter,
  practices,
  isPracticesLoading,
  setDebouncedInputPracticeValue,
  operators,
  isOperatorsLoading,
  setDebouncedInputOperatorValue,
}) => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedPractice, setSelectedPractice] = useState();
  const [studio, setStudio] = useState();
  const [selectedOperator, setSelectedOperator] = useState();

  const [formData, setFormData] = useState({
    adminId: "",
    practiceId: "",
    status: "",
  });

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  //POPOVER HANDLERS
  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleFilter = () => {
    setFilter((prev) => ({
      ...prev,
      adminId: formData.adminId,
      practiceId: formData.practiceId,
      status: formData.status,
    }));
    //handleClosePopover();
  };

  const handleReset = () => {
    setFormData((prev) => ({
      ...prev,
      adminId: "",
      practiceId: "",
      status: "",
    }));
    setFilter((prev) => ({
      ...prev,
      adminId: "",
      practiceId: "",
      status: "",
    }));
    setSelectedOperator();
    setSelectedPractice();
  };

  useEffect(() => {
    if (studio?.id)
      setFormData({
        ...formData,
        studioId: studio?.id,
      });
    else
      setFormData({
        ...formData,
        studioId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studio?.id]);

  useEffect(() => {
    if (selectedOperator?.id)
      setFormData({
        ...formData,
        adminId: selectedOperator?.id,
      });
    else
      setFormData({
        ...formData,
        adminId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperator?.id]);

  useEffect(() => {
    if (selectedCompany?.value)
      setFormData({
        ...formData,
        companyId: selectedCompany?.value,
      });
    else
      setFormData({
        ...formData,
        companyId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompany?.value]);

  useEffect(() => {
    if (selectedPractice?.value)
      setFormData({
        ...formData,
        practiceId: selectedPractice?.value,
      });
    else
      setFormData({
        ...formData,
        practiceId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPractice?.value]);

  return (
    <div>
      <CoreFilterButtonIcon onOpen={handleOpenPopover} />
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { borderRadius: "8px", marginTop: "5px", overflow: "visible" },
        }}
      >
        <div className="w-[30rem] p-4">
          <form className="flex flex-col ">
            <div className="flex flex-col">
              <h3 className="mb-2">{t("Operator")}</h3>
              <UserFilter //filtro per operatore
                selectedUser={selectedOperator}
                setSelectedUser={(e) => {
                  setSelectedOperator(e);
                }}
                usersList={operators?.Data?.items || []}
                setDebouncedInputUserValue={setDebouncedInputOperatorValue}
                isUsersLoading={isOperatorsLoading}
                externalLabel={t("BriefSearchOperator")}
                externalPlaceholder={t("ExtSearchOperator")}
                externalNegativeLabel={t("NoOperatorFound")}
                startAdornment={<SearchRoundedIcon size={20} />}
              />
            </div>

            {appConfig?.modules?.practice?.general && (
              <div className="flex flex-col">
                <h3 className="mb-2">{t("Practice")}</h3>
                <PracticeFilter
                  selectedUser={selectedPractice}
                  setSelectedUser={(v) => {
                    setSelectedPractice(v);
                  }}
                  usersList={
                    practices?.Data?.items.map((el) => ({
                      label: el.name,
                      value: el.id,
                    })) || []
                  }
                  isUsersLoading={isPracticesLoading}
                  setDebouncedInputUserValue={setDebouncedInputPracticeValue}
                  startAdornment={<SearchRoundedIcon size={20} />}
                />
              </div>
            )}
            <div className="flex space-x-4  justify-center">
              <Button
                className="bg-red-700 text-white w-full"
                onClick={handleReset}
                sx={{ marginTop: "16px" }}
              >
                Reset
              </Button>
              {/*               <Button
                className="text-white w-full"
                style={{ backgroundColor: `${colorPrimary}` }}
                onClick={handleFilter}
                sx={{ marginTop: "16px" }}
              >
                {t("Apply")}
              </Button> */}
            </div>
          </form>
        </div>
      </Popover>
    </div>
  );
};

export default ChatFilter;
